import React from 'react';
import './App.css';
import IndexPage from './pages';

function App() {
  return (
    <div className="full">
      <IndexPage />
    </div>
  );
}

export default App;
